export const enum SupportChatEscalationStatus {
    Created = 0,
    Duplicate = 1,
    Failed = 2,
    Invalid = 3,
    CreatedFollowUp = 4
}
